import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody } from "shards-react";
import moment from "moment";
import classNames from "classnames";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { collection, doc, updateDoc } from "firebase/firestore";
import { NavLink } from "react-router-dom";
import "../admin/userDetails/tab.css";
import { db } from "../../firebase";
import "../pagination.css";
import "./style.css";
import {
  checkDateForColorView,
  checkDateisAfterToday
} from "../../utils/common_handlers";
import { useUsersData } from "../../providers/UsersDataProvider";
import { getDocsFromServer } from "firebase/firestore";

import sdImage from "../../assets/dashboard/sd.svg";
import csdImage from "../../assets/dashboard/csd.svg";
import dbImage from "../../assets/dashboard/db.svg";
import threePlusImage from "../../assets/dashboard/3+.svg";
import eolImage from "../../assets/dashboard/eol.svg";
import changesImage from "../../assets/dashboard/changes.svg";
import guardianImage from "../../assets/dashboard/guardian.png";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TablePaginationActions from "./TablePaginationActions";

import EnhancedTableHead from "./EnhancedTableHead";
const Dashboard = () => {
                          const { Users } = useUsersData();
                          const [
                            userCountLoading,
                            setUserCountLoading
                          ] = useState(false);
                          const [usersCount, setUsersCount] = useState(0);
                          const [
                            activeUserCount,
                            setActiveUserCount
                          ] = useState(0);
                          const [
                            inactiveUserCount,
                            setInActiveUserCount
                          ] = useState(0);

                          const [displaySession, setDisplaySession] = useState(
                            "0"
                          );
                          const [sessionDataAll, setSessionDataAll] = useState(
                            []
                          ); // all session users
                          const [sessionData1, setSessionData1] = useState([]); //last 1 days of session users
                          const [
                            sessionData2To3,
                            setSessionData2To3
                          ] = useState([]); // last 2-3 days of session users
                          const [
                            sessionData4Plus,
                            setSessionData4Plus
                          ] = useState([]); // last 4 days and abouve of session users
                          const [
                            anySessionClicked,
                            setAnySessionClicked
                          ] = useState(true);
                          const [order, setOrder] = React.useState("desc");
                          const [orderBy, setOrderBy] = React.useState(
                            "LastSessionDoneAt"
                          );
                          const [page, setPage] = React.useState(0);
                          const [rowsPerPage, setRowsPerPage] = React.useState(
                            25
                          );

                          useEffect(() => {
                            async function getUsersCount() {
                              const userColection = collection(db, "UserData");
                              setUserCountLoading(true);
                              const totalDocs = await getDocsFromServer(
                                userColection
                              );
                              let totalCount = 0;
                              let activeUsersCount = 0;
                              let inActiveUsersCount = 0;
                              totalDocs.docs.forEach(doc => {
                                totalCount = totalCount + 1;
                                if (
                                  doc.data().ValidTill &&
                                  checkDateisAfterToday(
                                    doc
                                      .data()
                                      .ValidTill.toDate()
                                      .toDateString()
                                  )
                                ) {
                                  activeUsersCount = activeUsersCount + 1;
                                } else {
                                  inActiveUsersCount = inActiveUsersCount + 1;
                                }
                              });
                              setUserCountLoading(false);
                              setUsersCount(totalCount);
                              setActiveUserCount(activeUsersCount);
                              setInActiveUserCount(inActiveUsersCount);
                            }
                            getUsersCount();
                            // getUsersDashboardCount();
                          }, []);

                          const handleChangePage = (event, newPage) => {
                            setPage(newPage);
                          };

                          const handleChangeRowsPerPage = event => {
                            setRowsPerPage(+event.target.value);
                            setPage(0);
                          };

                          useEffect(() => {
                            setSessionDataAll(Users);
                            setSessionData4Plus([]);
                            setSessionData2To3([]);
                            setSessionData1([]);
                            Users.forEach(user => {
                              if (user.SessionDoneDaysAgo >= 4) {
                                setSessionData4Plus(prev => [
                                  ...prev,
                                  { ...user }
                                ]);
                              } else if (
                                user.SessionDoneDaysAgo >= 2 &&
                                user.SessionDoneDaysAgo <= 3
                              ) {
                                setSessionData2To3(prev => [
                                  ...prev,
                                  { ...user }
                                ]);
                              } else if (user.SessionDoneDaysAgo === 1) {
                                setSessionData1(prev => [...prev, { ...user }]);
                              }
                            });
                          }, [Users, anySessionClicked]);

                          function descendingComparator(a, b, orderBy) {
                            if (a[orderBy] === undefined) return 1; // `a` should come after `b`
                            if (b[orderBy] === undefined) return -1; // `b` should come after `a`

                            if (b[orderBy] < a[orderBy]) {
                              return -1;
                            }
                            if (b[orderBy] > a[orderBy]) {
                              return 1;
                            }
                            return 0;
                          }

                          function getComparator(order, orderBy) {
                            return order === "desc"
                              ? (a, b) => descendingComparator(a, b, orderBy)
                              : (a, b) => -descendingComparator(a, b, orderBy);
                          }

                          function stableSort(array, comparator) {
                            const stabilizedThis = array.map((el, index) => [
                              el,
                              index
                            ]);
                            stabilizedThis.sort((a, b) => {
                              const order = comparator(a[0], b[0]);
                              if (order !== 0) {
                                return order;
                              }
                              return a[1] - b[1];
                            });
                            return stabilizedThis.map(el => el[0]);
                          }

                          const getDataToSort = displaySession => {
                            switch (displaySession) {
                              case "0":
                                return Users;
                              case "1-2":
                                return sessionData1;
                              case "3-6":
                                return sessionData2To3;
                              case "7":
                                return sessionData4Plus;
                              default:
                                return sessionDataAll;
                            }
                          };

                          const visibleRows = React.useMemo(() => {
                            const dataToSort = getDataToSort(displaySession);
                            return stableSort(
                              dataToSort,
                              getComparator(order, orderBy)
                            ).slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            );
                          }, [displaySession, Users, order, orderBy, page]);

                          const handleRequestSort = (event, property) => {
                            const isAsc =
                              orderBy === property && order === "desc";
                            setOrder(isAsc ? "asc" : "desc");
                            setOrderBy(property);
                          };

                          const handleLoadDataCall = session => {
                            setDisplaySession(session);
                            setAnySessionClicked(true);
                          };

                          const makeUserStarred = async (uid, starValue) => {
                            const userRef = doc(db, "UserData", uid);
                            await updateDoc(userRef, {
                              Starred: !starValue
                            });
                          };

                          const makeUserAsSchoolKid = async (uid, value) => {
                            const userRef = doc(db, "UserData", uid);
                            await updateDoc(userRef, {
                              SchoolKid: !value
                            });
                          };

                          return (
                            <Container
                              fluid
                              className="main-content-container px-4 pb-4"
                            >
                              {userCountLoading ? (
                                <div className="wrapper">
                                  <div className="spinner">
                                    <div className="spinner-1"></div>
                                    <div className="spinner-2"></div>
                                    <div className="spinner-3"></div>
                                  </div>
                                </div>
                              ) : (
                                <Row className="page-header py-4">
                                  <Col className="col-lg mb-4">
                                    <Card small className={cardClasses}>
                                      <CardBody className={cardBodyClasses}>
                                        <div className={innerWrapperClasses}>
                                          <div className={dataFieldClasses}>
                                            <span className={labelClasses}>
                                              Total Users
                                            </span>
                                            <h6 className={valueClasses}>
                                              {usersCount}
                                            </h6>
                                          </div>
                                        </div>
                                      </CardBody>
                                    </Card>
                                  </Col>
                                  <Col className="col-lg mb-4">
                                    <Card small className={cardClasses}>
                                      <CardBody className={cardBodyClasses}>
                                        <div className={innerWrapperClasses}>
                                          <div className={dataFieldClasses}>
                                            <span className={labelClasses}>
                                              Active Users
                                            </span>
                                            <h6 className={valueClasses}>
                                              {activeUserCount}
                                            </h6>
                                          </div>
                                        </div>
                                      </CardBody>
                                    </Card>
                                  </Col>
                                  <Col className="col-lg mb-4">
                                    <Card small className={cardClasses}>
                                      <CardBody className={cardBodyClasses}>
                                        <div className={innerWrapperClasses}>
                                          <div className={dataFieldClasses}>
                                            <span className={labelClasses}>
                                              InActive Users
                                            </span>
                                            <h6 className={valueClasses}>
                                              {inactiveUserCount}
                                            </h6>
                                          </div>
                                        </div>
                                      </CardBody>
                                    </Card>
                                  </Col>
                                </Row>
                              )}
                              <Row className="page-header py-4">
                                <Col>
                                  <button
                                    className={`customBtn ${
                                      displaySession === "0"
                                        ? "greenBg"
                                        : "greenBtn"
                                    }`}
                                    onClick={() => handleLoadDataCall("0")}
                                  >
                                    All training
                                  </button>
                                </Col>
                                <Col>
                                  <button
                                    className={`customBtn ${
                                      displaySession === "1-2"
                                        ? "orangeBg"
                                        : "orangeBtn"
                                    }`}
                                    onClick={() => handleLoadDataCall("1-2")}
                                  >
                                    Missed 1 day
                                  </button>
                                </Col>
                                <Col>
                                  <button
                                    className={`customBtn ${
                                      displaySession === "3-6"
                                        ? "purpleBg"
                                        : "purpleBtn"
                                    }`}
                                    onClick={() => handleLoadDataCall("3-6")}
                                  >
                                    Missed 2-3 days
                                  </button>
                                </Col>
                                <Col>
                                  <button
                                    className={`customBtn ${
                                      displaySession === "7"
                                        ? "redBg"
                                        : "redBtn"
                                    }`}
                                    onClick={() => handleLoadDataCall("7")}
                                  >
                                    Missed 4+ days
                                  </button>
                                </Col>
                              </Row>

                              <Row className="page-header py-4">
                                <Paper
                                  sx={{ width: "100%", overflow: "hidden" }}
                                >
                                  {Users.length < 1 ? (
                                    <div
                                      style={{
                                        height: "80vh",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                      }}
                                    >
                                      <div className="spinner">
                                        <div className="spinner-1"></div>
                                        <div className="spinner-2"></div>
                                        <div className="spinner-3"></div>
                                      </div>
                                    </div>
                                  ) : (
                                    <TableContainer>
                                      <Table
                                        stickyHeader
                                        aria-label="sticky table"
                                      >
                                        <EnhancedTableHead
                                          order={order}
                                          orderBy={orderBy}
                                          onRequestSort={handleRequestSort}
                                          rowCount={Users.length}
                                        />{" "}
                                        <TableBody>
                                          {visibleRows &&
                                            visibleRows.map(user => (
                                              <TableRow key={user.uid}>
                                                <TableCell
                                                  align="center"
                                                  style={{
                                                    borderRight:
                                                      "1px solid #d3d3d3",
                                                    fontSize: "12px"
                                                  }}
                                                >
                                                  <NavLink
                                                    to={`/user-details/${user.uid}`}
                                                    style={{
                                                      color: "inherit",
                                                      fontSize: "0.9em",
                                                      fontWeight: 500,
                                                      padding: 0,
                                                      wordWrap: "break-word",
                                                      textAlign: "center",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                      height: "30px"
                                                    }}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                  >
                                                    {user.FirstName}
                                                    {user.UserType &&
                                                      user.UserType ===
                                                        "Guardian" && (
                                                        <img
                                                          className="guardianIcon"
                                                          src={guardianImage}
                                                          alt="Guardian"
                                                        />
                                                      )}
                                                  </NavLink>
                                                </TableCell>

                                                <TableCell
                                                  align="center"
                                                  style={{
                                                    borderRight:
                                                      "1px solid #d3d3d3",
                                                    fontSize: "12px"
                                                  }}
                                                >
                                                  <div
                                                    className="centerItems"
                                                    style={{
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                      height: "30px",
                                                      fontSize: "12px"
                                                    }}
                                                  >
                                                    {user.FirstSessionDoneOn
                                                      ? moment(
                                                          user.FirstSessionDoneOn.toDate().toDateString()
                                                        ).format("MMM Do YY")
                                                      : "-"}
                                                  </div>
                                                </TableCell>
                                                <TableCell
                                                  align="center"
                                                  style={{
                                                    borderRight:
                                                      "1px solid #d3d3d3",
                                                    fontSize: "12px"
                                                  }}
                                                >
                                                  <span
                                                    className="centerItems"
                                                    style={{
                                                      color: checkDateForColorView(
                                                        user.LastSessionDoneAt &&
                                                          user.LastSessionDoneAt.toDate().toDateString()
                                                      ),
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                      height: "30px",
                                                      fontSize: "12px"
                                                    }}
                                                  >
                                                    {user.LastSessionDoneAt
                                                      ? `${moment(
                                                          user.LastSessionDoneAt.toDate().toDateString()
                                                        ).format("MMM Do YY")}`
                                                      : "-"}
                                                  </span>
                                                </TableCell>
                                                <TableCell
                                                  align="center"
                                                  style={{
                                                    borderRight:
                                                      "1px solid #d3d3d3",
                                                    fontSize: "12px"
                                                  }}
                                                >
                                                  <div
                                                    className="centerItems"
                                                    style={{
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                      height: "30px",
                                                      fontSize: "12px"
                                                    }}
                                                  >
                                                    {user.nextTestDate
                                                      ? moment(
                                                          user.nextTestDate
                                                        ).format("MMM Do YY")
                                                      : "-"}
                                                  </div>
                                                </TableCell>

                                                <TableCell
                                                  align="center"
                                                  style={{
                                                    borderRight:
                                                      "1px solid #d3d3d3",
                                                    fontSize: "12px"
                                                  }}
                                                >
                                                  <div
                                                    className="centerItems"
                                                    style={{
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                      height: "30px",
                                                      fontSize: "12px"
                                                    }}
                                                  >
                                                    {user.CalibScore ? (
                                                      <>
                                                        <span>
                                                          {user.CalibScore}
                                                        </span>
                                                        {user.sign === "up" ? (
                                                          <i
                                                            className="material-icons"
                                                            style={{
                                                              cursor: "pointer",
                                                              top: "0px"
                                                            }}
                                                          >
                                                            arrow_upward
                                                          </i>
                                                        ) : user.sign ===
                                                          "down" ? (
                                                          <i
                                                            className="material-icons"
                                                            style={{
                                                              cursor: "pointer",
                                                              top: "0px"
                                                            }}
                                                          >
                                                            arrow_downward
                                                          </i>
                                                        ) : (
                                                          <i
                                                            className="material-icons"
                                                            style={{
                                                              cursor: "pointer",
                                                              top: "0px"
                                                            }}
                                                          >
                                                            horizontal_rule
                                                          </i>
                                                        )}
                                                      </>
                                                    ) : (
                                                      "-"
                                                    )}
                                                  </div>
                                                </TableCell>

                                                <TableCell
                                                  align="center"
                                                  style={{
                                                    borderRight:
                                                      "1px solid #d3d3d3",
                                                    fontSize: "12px"
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                      height: "30px",
                                                      fontSize: "12px"
                                                    }}
                                                  >
                                                    <div>
                                                      {user.StandardDeviation
                                                        ? user.StandardDeviation +
                                                          "%"
                                                        : "-"}
                                                    </div>
                                                  </div>
                                                </TableCell>

                                                <TableCell
                                                  align="center"
                                                  style={{
                                                    borderRight:
                                                      "1px solid #d3d3d3",
                                                    fontSize: "12px"
                                                  }}
                                                >
                                                  <div
                                                    className="centerItems"
                                                    style={{
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                      height: "30px",
                                                      fontSize: "12px"
                                                    }}
                                                  >
                                                    {user.CalibrationStandardDeviation
                                                      ? user.CalibrationStandardDeviation +
                                                        "%"
                                                      : "-"}
                                                  </div>
                                                </TableCell>

                                                <TableCell
                                                  align="center"
                                                  style={{
                                                    borderRight:
                                                      "1px solid #d3d3d3",
                                                    fontSize: "12px"
                                                  }}
                                                >
                                                  <div
                                                    className="actionIconContainer centerItems actionColumn"
                                                    style={{ height: "30px" }}
                                                  >
                                                    <div className="actionIconWrapper">
                                                      {user.StandardDeviationIcon && (
                                                        <img
                                                          src={sdImage}
                                                          title={
                                                            "Training Standard deviation"
                                                          }
                                                          className="actionIcon"
                                                          alt="tsdIcon"
                                                        />
                                                      )}
                                                    </div>
                                                    <div className="actionIconWrapper">
                                                      {user.CalibrationStandardDeviationIcon && (
                                                        <img
                                                          src={csdImage}
                                                          title={
                                                            "Calibration Standard deviation"
                                                          }
                                                          className="actionIcon"
                                                          alt="csdIcon"
                                                        />
                                                      )}
                                                    </div>
                                                    <div className="actionIconWrapper">
                                                      {user.ReadCalibrationFromBackend && (
                                                        <img
                                                          src={dbImage}
                                                          title={
                                                            "Read Calibration from backend"
                                                          }
                                                          className="actionIcon"
                                                          alt="rcbIcon"
                                                        />
                                                      )}
                                                    </div>
                                                    <div className="actionIconWrapper">
                                                      {user.SessionDoneDaysAgo &&
                                                      user.SessionDoneDaysAgo >=
                                                        3 ? (
                                                        <img
                                                          src={threePlusImage}
                                                          title={
                                                            "Session done 3 or more days ago"
                                                          }
                                                          className="actionIcon"
                                                          alt="sessionDoneIcon"
                                                        />
                                                      ) : (
                                                        ""
                                                      )}
                                                    </div>
                                                    <div className="actionIconWrapper">
                                                      {user.ValidTill &&
                                                      moment(
                                                        user.ValidTill.toDate().toDateString()
                                                      ).isBefore() ? (
                                                        <img
                                                          src={eolImage}
                                                          title={"Expired"}
                                                          className="actionIcon"
                                                          alt="expired"
                                                        />
                                                      ) : (
                                                        ""
                                                      )}
                                                    </div>
                                                    <div className="actionIconWrapper">
                                                      {user.ChangeFlag &&
                                                        user.ChangeFlag && (
                                                          <img
                                                            src={changesImage}
                                                            title={
                                                              "Changes made"
                                                            }
                                                            className="actionIcon"
                                                            alt="changedMadeIcon"
                                                          />
                                                        )}
                                                    </div>
                                                    <div className="actionIconWrapper">
                                                      {user.UserAnswers &&
                                                        user.UserAnswers
                                                          .length >= 1 && (
                                                          <span
                                                            className="actionIconText"
                                                            title={
                                                              "Latest vergence test number"
                                                            }
                                                          >
                                                            {
                                                              user.UserAnswers
                                                                .length
                                                            }
                                                          </span>
                                                        )}
                                                    </div>
                                                    {/* <button type="button" className="btn btn-info" style={{ zIndex: 1 }} onClick={() => resetPasswordModal(row.Email)}>Reset Password</button>
          <button type="button" disabled={deletingUser && deletingUserId === row.uid} className="btn btn-danger" style={{ zIndex: 1 }}
            onClick={() => { deleteUser(row.uid) }}
          >
            Delete
          </button> */}
                                                  </div>
                                                </TableCell>

                                                <TableCell
                                                  align="center"
                                                  style={{
                                                    borderRight:
                                                      "1px solid #d3d3d3",
                                                    fontSize: "12px"
                                                  }}
                                                >
                                                  <div
                                                    className="rating centerItems"
                                                    st
                                                  >
                                                    <span
                                                      className={
                                                        user.Starred
                                                          ? "starred"
                                                          : ""
                                                      }
                                                      onClick={() =>
                                                        makeUserStarred(
                                                          user.uid,
                                                          user.Starred
                                                        )
                                                      }
                                                    >
                                                      ☆
                                                    </span>
                                                  </div>
                                                </TableCell>

                                                <TableCell
                                                  align="center"
                                                  style={{
                                                    borderRight:
                                                      "1px solid #d3d3d3",
                                                    fontSize: "12px"
                                                  }}
                                                >
                                                  <div
                                                    className="centerItems"
                                                    style={{ height: "30px" }}
                                                  >
                                                    <div className="form-check ">
                                                      <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        checked={
                                                          user.SchoolKid
                                                            ? true
                                                            : false
                                                        }
                                                        onChange={() =>
                                                          makeUserAsSchoolKid(
                                                            user.uid,
                                                            user.SchoolKid
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  </div>
                                                </TableCell>

                                                <TableCell
                                                  align="center"
                                                  style={{
                                                    borderRight:
                                                      "1px solid #d3d3d3",
                                                    fontSize: "12px"
                                                  }}
                                                >
                                                  {}
                                                  <a
                                                    className="centerItems"
                                                    target={"_blank"}
                                                    rel="noreferrer"
                                                    href={`https://statistics-imvi.web.app/Answers?Email=${encodeURIComponent(
                                                      user.Email
                                                    )}`}
                                                  >
                                                    <img
                                                      src={require("../../assets/dashboard/statistics.png")}
                                                      alt={"Report"}
                                                      title={
                                                        "User Answers Report"
                                                      }
                                                      style={{ width: "30px" }}
                                                    />
                                                  </a>
                                                </TableCell>
                                                {/* ... other columns ... */}
                                              </TableRow>
                                            ))}
                                        </TableBody>
                                      </Table>
                                      <TablePagination
                                        rowsPerPageOptions={[50]}
                                        component="div"
                                        count={
                                          getDataToSort(displaySession).length
                                        }
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={
                                          handleChangeRowsPerPage
                                        }
                                        ActionsComponent={
                                          TablePaginationActions
                                        }
                                      />
                                    </TableContainer>
                                  )}
                                </Paper>
                              </Row>
                            </Container>
                          );
                        };
const variation = "1";
const cardClasses = classNames(
  "stats-small",
  variation && `stats-small--${variation}`
);

const cardBodyClasses = classNames(
  variation === "1" ? "p-0 d-flex" : "px-0 pb-0"
);

const innerWrapperClasses = classNames(
  "d-flex",
  variation === "1" ? "flex-column m-auto" : "px-3"
);

const dataFieldClasses = classNames(
  "stats-small__data",
  variation === "1" && "text-center"
);

const labelClasses = classNames(
  "stats-small__label",
  "text-uppercase",
  variation !== "1" && "mb-1"
);

const valueClasses = classNames(
  "stats-small__value",
  "count",
  variation === "1" ? "my-3" : "m-0"
);

export default Dashboard;
